import { createMemoryHistory, RouterProvider } from "@tanstack/react-router";
import { useRef } from "react";
import { useSession } from "../auth/SessionProvider";
import { createRouterWithAuth } from "./router";
import {
  createSessionAuthProjection,
  projectSessionAuth,
} from "./session-projection";

type RouterProviderIntegrationProps = {
  initialEntries?: string[];
};

export function RouterProviderIntegration({
  initialEntries,
}: RouterProviderIntegrationProps = {}) {
  const session = useSession();
  const sessionRef = useRef(session);
  sessionRef.current = session;

  const authRef = useRef<ReturnType<typeof createSessionAuthProjection>>();
  if (!authRef.current) {
    authRef.current = createSessionAuthProjection({
      getSnapshot: () => projectSessionAuth(sessionRef.current.getSnapshot()),
      ready: async () => projectSessionAuth(await sessionRef.current.ready()),
      subscribe: (listener) => sessionRef.current.subscribe(listener),
    });
  }

  const routerRef = useRef<ReturnType<typeof createRouterWithAuth>>();
  if (!routerRef.current) {
    const history = initialEntries
      ? createMemoryHistory({ initialEntries })
      : undefined;
    routerRef.current = createRouterWithAuth(authRef.current, history);
  }

  return <RouterProvider router={routerRef.current} />;
}
